import Separator from "components/separator";
import type { LiabilityFormLayout } from "../types";

export const separator = (): LiabilityFormLayout => ({
  component: () => () => <Separator size="s" variant="gray" />
})
